<ng-http-loader spinner="sk-double-bounce" [backgroundColor]="'#17BCBE'"
    [filteredUrlPatterns]="['/sequation-user-api/checkHeartbeat', '/sequation-user-api/refreshToken', '/sequation-job-api/ref-data/what/', '/sequation-job-api/ref-data/where/' ]">
</ng-http-loader>
<router-outlet></router-outlet>
